import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import { Carousel } from "react-bootstrap"

import { Container, Divisoria, SlideStyled } from "./styled"

const SlideView = props => {
  const { cliente01, cliente02, cliente03, cliente04 } = useStaticQuery(graphql`
    query {
      cliente01: file(relativePath: { eq: "cliente01.png" }) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 400) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      cliente02: file(relativePath: { eq: "cliente02.png" }) {
        childImageSharp {
          fluid(maxWidth: 1250, maxHeight: 1300) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      cliente03: file(relativePath: { eq: "cliente03.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1100, maxHeight: 1100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }

      cliente04: file(relativePath: { eq: "cliente04.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 110) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)
  return (
    <>
      <Container>
        <Divisoria>
          <div className="nome-divisoria">
            <h2>Projetos Recentes</h2>
          </div>
        </Divisoria>

        <SlideStyled>
          <div className="slide-container">
            <Carousel className="carousel">
              <Carousel.Item>
                <Img
                  fluid={cliente01.childImageSharp.fluid}
                  alt="Dev Dojo sistemas"
                />
              </Carousel.Item>
              <Carousel.Item>
                <Img fluid={cliente02.childImageSharp.fluid} alt="Líder Gas" />
              </Carousel.Item>
              <Carousel.Item>
                <Img
                  fluid={cliente03.childImageSharp.fluid}
                  alt="Giros Moto Peças"
                />
              </Carousel.Item>
              <Carousel.Item>
                <Img
                  fluid={cliente04.childImageSharp.fluid}
                  alt="Universo Locações de Bombas"
                />
              </Carousel.Item>
            </Carousel>
          </div>
        </SlideStyled>
      </Container>
    </>
  )
}

export default SlideView
